<template>
  <div class="container wrapper" v-if="homeData">
    <!-- 已预约 -->
    <template v-if="isSubmit">
      <div class="success-card">
        <div class="card-title">
          <svg
            class="svg"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              fill="#13bf80"
              transform="translate(-134.34 -119.68)"
              d="M146.34,119.68a12,12,0,1,0,12,12A12,12,0,0,0,146.34,119.68Zm6.883,8.887-7.762,7.762a1.085,1.085,0,0,1-1.536,0l-4.467-4.47a1.086,1.086,0,1,1,1.535-1.535l3.7,3.7,6.994-6.993a1.086,1.086,0,0,1,1.536,1.536Zm0,0"
            />
          </svg>
          <span>恭喜您，预约成功！</span>
        </div>
        <div class="live-infor">
          <p class="name">{{ homeData.name }}</p>
          <div class="describe">
            <p class="text">直播时间：</p>
            <p class="text">{{ homeData.nostart.centralCourseLiveTime }}</p>
          </div>
          <div class="describe">
            <p class="text">主讲老师：</p>
            <p class="text">{{ homeData.anchor_info.name }}</p>
          </div>
        </div>

        <p class="success-tips">
          <span>距离直播开始还有</span>
          <template v-if="countDownTime.day > 0">
            <span class="font">{{ countDownTime.day }}</span>
            天
          </template>
          <template v-else-if="countDownTime.hour > 0">
            <span class="font">{{ countDownTime.hour }}</span>
            小时
          </template>
          <template v-else-if="countDownTime.minute > 0">
            <span class="font">{{ countDownTime.minute }}</span>
            分钟
          </template>
          <template v-else>
            <span class="font">{{ countDownTime.second }}</span>
            秒
          </template>
          <span>，开播前我们将短信通知您</span>
        </p>
        <p class="success-tips">您也可以前往“{{ brandName }}APP-课程”中观看</p>
        <OpenApp unitKey="CourseDetail" :options="{ no: homeData.course_no }">
          <van-button round type="primary" class="open-button">打开{{ brandName }}APP</van-button>
        </OpenApp>
      </div>
    </template>

    <!-- 未预约 -->
    <template v-else>
      <div class="booking-card">
        <div class="page-title">
          <div class="title">预约观看直播</div>
          <div class="subtitle">预约成功后，开播前将短信通知您</div>
        </div>
        <van-cell-group class="form" :border="false">
          <van-field
            class="form-item"
            placeholder="请输入手机号"
            type="number"
            center
            v-model="phoneValue"
            :border="false"
            :clearable="true"
            :maxlength="11"
            @focus="focusInput"
          />

          <van-field
            class="form-item"
            placeholder="请输入验证码"
            type="number"
            center
            v-model="codeValue"
            :border="false"
            :clearable="true"
            :maxlength="4"
            @focus="focusInput"
          >
            <template #right-icon>
              <div
                class="text"
                :class="isDisableCode ? 'text-disable' : ''"
                @click="getImageCode()"
              >
                <span :class="{ text: countTimer !== -1 }">{{ codeText }}</span>
                <span v-if="countTimer !== -1">重新发送</span>
              </div>
            </template>
          </van-field>
        </van-cell-group>
        <div style="padding-bottom: 20px" ref="submitButton">
          <van-button round type="primary" class="button" @click="submitLiveBooking">
            确定预约
          </van-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import mixinLogin from '@/mixin/login'
import { getBookingHomeApi, checkTencentCodeApi, submitLiveBookingApi } from '@/api/live/booking'
import { formatTime, formatSingleNumber } from '@/utils/date'
import OpenApp from '@/components/OpenApp.vue'
import { getCurrentBrand } from '@/config/brand'
export default {
  data() {
    return {
      homeData: null,
      isSubmit: false,
      course_no: '',
      course_id: '', //课程id
      brandName: '',
    }
  },
  mixins: [mixinLogin],
  computed: {
    buttonDisabled() {
      let phoneValue = this.phoneValue,
        codeValue = this.codeValue
      return phoneValue.length >= 11 && codeValue.length >= 4
    },
    // 剩余直播时间
    surplusTimeStamp() {
      // 用于测试剩余时长
      if (this.$route.query.surplusTimeStamp) {
        return parseInt(this.$route.query.surplusTimeStamp)
      }
      const time =
        this.homeData.nostart.centralCourseLiveTimeTimeStamp - Date.parse(new Date()) / 1000
      if (time <= 0) {
        return 0
      }
      return time
    },
    // 倒计时
    countDownTime() {
      return formatTime(this.surplusTimeStamp)
    },
  },
  methods: {
    formatSingleNumber,
    // 获取表单需要的一些数据
    async getBookingHome() {
      const params = this.routeFixedParam()
      params.id = this.course_id
      params.course_no = this.course_no
      params.fileid = ''
      const respose = await getBookingHomeApi(params).catch((err) => {
        console.log(err)
      })
      const resposeData = respose?.data || null
      this.homeData = resposeData
      // 时间到了自动跳转
      // if (this.surplusTimeStamp <= 0) {
      //     this.toLivePlay()
      // }
      // 带有参数的页面不自动跳转
      if (this.$route.query.submit) {
        return false
      }
      // 不是直播未开始状态 直接返回直播页面
      if (this.homeData.live_info.live_status !== 0) {
        this.toLivePlay()
      }
      if (this.homeData.nostart.isReservation) {
        this.$toast('您已预约当前直播')
        setTimeout(() => {
          this.toLivePlay()
        }, 2500)
      }
    },
    // 获取图形验证码
    getImageCode() {
      if (this.isDisableCode) return
      let verifyPhoneResult = this.verifyPhoneValue()
      if (!verifyPhoneResult.result) {
        this.$toast(verifyPhoneResult.msg)
        return
      }
      let captchaId = this.homeData.captcha //腾讯滑块验证码appid
      //生成一个滑块验证码对象
      var captcha = new TencentCaptcha(captchaId, (res) => {
        if (res.ret === 0) {
          // 页面上滑动正确，请求自己的业务接口
          // 记得把验证成功的票据和随机字符带到自己接口中去腾讯验证票据的真实性
          this.checkTencentCode(res.ticket, res.randstr)
        }
      })
      captcha.langFun()
      // 滑块显示
      captcha.show()
    },
    // 验图形验证码且发送短信
    async checkTencentCode(ticket, randstr) {
      const params = this.routeFixedParam()
      params.Ticket = ticket
      params.Randstr = randstr
      params.mobile = this.phoneValue
      params.course_no = this.course_no
      params.video_no = this.$route.query.video_no
      const respose = await checkTencentCodeApi(params).catch((err) => console.log(err))
      const resposeData = respose?.data || null
      if (!resposeData) {
        this.$toast('图形验证码异常')
        return
      }
      // 验证码成功
      if (respose.status === 1) {
        this.openCodeTimer()
      }
      if (respose.status === 0) {
        if (respose.message) {
          this.$toast(respose.message)
        }
      }
      if (respose.status === 2) {
        this.$toast('您已预约当前直播')
        setTimeout(() => {
          this.toLivePlay()
        }, 2500)
      }
    },
    // 提交预约表单
    async submitLiveBooking() {
      let params = this.routeFixedParam()
      let verifyPhoneResult = this.verifyPhoneValue(),
        verifyCodeValueResult = this.verifyCodeValue()
      if (!verifyPhoneResult.result) {
        this.$toast(verifyPhoneResult.msg)
        return
      }
      if (!verifyCodeValueResult.result) {
        this.$toast(verifyCodeValueResult.msg)
        return
      }
      params.relate_id = this.homeData.id
      params.course_name = this.homeData.name
      params.enter_url = this.homeData.nostart.enter_url
      params.code = verifyCodeValueResult.value
      params.mobile = verifyPhoneResult.value
      params.course_no = this.course_no
      params.video_no = this.$route.query.video_no
      const respose = await submitLiveBookingApi(params).catch((err) => console.log(err))
      // 数据成功返回
      if (respose.status === 1) {
        this.isSubmit = true
        this.$util.replacePageState({}, '', window.location.href + '&submit=' + true)
        return false
      }
      // 已报名过
      if (respose.status === 2) {
        if (respose.message) {
          this.$toast(respose.message)
        }
        setTimeout(() => {
          this.toLivePlay()
        }, 2500)
        return false
      }
      // 其余情况有报错信息显示报错信息
      if (respose.message) {
        this.$toast(respose.message)
      }
    },
    toLivePlay() {
      let query = this.routeFixedParam()
      query.course_no = this.course_no
      query.id = this.course_id
      this.$router.push({
        path: '/live/play',
        query,
      })
    },
    // 获取焦点
    focusInput() {
      setTimeout(() => {
        this.$refs.submitButton.scrollIntoView(false)
      }, 100)
      console.log()
    },
  },
  created() {
    var script = document.createElement('script')
    script.setAttribute('type', 'text/javascript')
    script.setAttribute(
      'src',
      'https://statics-1253756937.cos.ap-chengdu.myqcloud.com/web_project/app_share/TCaptcha.js'
    )
    document.getElementsByTagName('head')[0].appendChild(script)

    this.brandName = getCurrentBrand.name
  },
  mounted() {
    this.course_no = this.$route.query.course_no
    this.course_id = this.$route.query.id
    this.getBookingHome()
    if (this.$route.query.submit) {
      this.isSubmit = true
    }
  },
  components: { OpenApp },
}
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: #fff;
}

.booking-card {
  padding-left: 0.32rem;
  padding-right: 0.32rem;

  .page-title {
    margin-bottom: 0.5rem;
    padding-top: 1rem;
    margin-bottom: 1.7rem;

    .title {
      font-size: 0.69rem;
      line-height: 0.88rem;
      font-weight: 500;
      margin-bottom: 0.2rem;
    }

    .subtitle {
      font-size: 0.37rem;
      color: #919499;
    }
  }

  .form {
    margin-bottom: 2.13rem;

    &-item {
      border-bottom: 0.01rem solid #ebecf0;
      height: 1.36rem;

      & + .form-item {
        margin-top: 0.7rem;
      }

      /deep/.van-field__control {
        font-size: 0.4rem;
      }

      .text {
        font-size: 0.34rem;
        font-weight: 400;
        color: var(--main-color);
        width: 2.4rem;
        text-align: right;
        box-sizing: border-box;

        &-disable {
          color: #c2c5cc;
        }
      }
    }
  }

  .button {
    width: 100%;
    font-size: 0.4rem;
  }
}

.success-card {
  padding-top: 1.6rem;

  .card-title {
    @include flex_center;
    font-size: 0.53rem;
    font-weight: 500;
    color: #22242e;
    margin-bottom: 1rem;

    .svg {
      margin-right: 0.27rem;
    }
  }

  .live-infor {
    background: rgba($color: #f7f8fa, $alpha: 0.6);
    border-radius: 0.21rem;
    padding: 0.53rem 0.43rem;
    margin-bottom: 1.71rem;

    .name {
      font-size: 0.35rem;
      line-height: 0.53rem;
      color: #22242e;
      opacity: 0.8;
      margin-bottom: 0.27rem;
    }

    .describe {
      display: flex;

      & + .describe {
        margin-top: 0.16rem;
      }

      .text {
        font-size: 0.32rem;
        font-weight: 400;
        color: #919499;
        opacity: 0.8;

        &:nth-child(1) {
          width: 1.76rem;
        }
      }
    }
  }

  .success-tips {
    font-size: 0.32rem;
    font-weight: 400;
    line-height: 0.51rem;
    color: rgba($color: #919499, $alpha: 0.8);
    text-align: center;
    margin-bottom: 0.16rem;

    .font {
      color: var(--main-color);
    }
  }

  .open-button {
    margin-top: 0.7rem;
    font-size: 0.4rem;
  }
}
</style>
